<template>
    <a :href="href" :tabindex="disabled ? -1 : 0" :class="disabled ? 'disabled' : 0" @click="onClick($event)" :target="target">
        <slot/>
        <form ref="form" :method="formMethod" :action="href" v-show="false"
              v-if="href && method.toUpperCase() !== 'GET'">
            <input type="hidden" name="_method" :value="method">
            <input type="hidden" name="_token" :value="token">
            <input v-for="(value, key) in linkData" type="hidden" :name="key" :value="value">
        </form>
    </a>
</template>

<script>
    export default {
        props: {
            href: {
                default: ''
            },
            target: {
                default: ''
            },
            preventDefault: {
                type: Boolean,
                default: null
            },
            block: {
                type: Boolean,
                default: false
            },
            method: {
                type: String,
                default: 'get'
            },
            linkData: {
                type: Object,
                default() {
                    return {};
                }
            },
            confirmMessage: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onClick(e) {
                if (this.isPreventDefault || this.isDisabled) {
                    e.preventDefault();
                }

                if (this.confirmMessage.length > 0) {
                    if (!confirm(this.confirmMessage)) {
                        e.preventDefault();
                        return;
                    }
                }

                if (this.href && !this.isPreventDefault && this.method.toUpperCase() !== 'GET') {
                    e.preventDefault();
                    this.$refs.form.submit();
                }

                this.$emit('click', e);
            }
        },
        computed: {
            formMethod() {
                return this.method === 'GET' ? 'GET' : 'POST';
            },
            isPreventDefault() {
                if (this.preventDefault === null) {
                    return !this.href;
                }
                return this.preventDefault;
            },
            token() {
                const csrfTokenMeta = document.head.querySelector('meta[name="csrf-token"]');
                return csrfTokenMeta ? csrfTokenMeta.content : '';
            }
        }
    }
</script>

<style scoped lang="scss">
    a ion-icon {
        position: relative;
        right: 5px;
    }
</style>
